import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import AICopilot from './AICopilot';
import './Layout.css';

const Layout = () => {
  const activeStaff = localStorage.getItem('gdt_active_staff');
  
  if (!activeStaff) {
    return <Navigate to="/login/staff" replace />;
  }

  return (
    <div className="layout">
      <Sidebar />
      <div className="main-container">
        <Header />
        <main className="content">
          <Outlet />
        </main>
      </div>
      <AICopilot />
    </div>
  );
};

export default Layout;
